var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import classNames from 'classnames';
import { mergeRefs } from './mergeRefs';
export var TabGroup = function (_a) {
    var _b;
    var className = _a.className, noBreak = _a.noBreak, children = _a.children, rest = __rest(_a, ["className", "noBreak", "children"]);
    var tabs = useState((_b = React.Children.map(children, function () { return React.createRef(); })) !== null && _b !== void 0 ? _b : [])[0];
    var handleKeyDown = function (e) {
        var _a, _b;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var currentFocus_1 = document.activeElement;
            var currentTab = tabs === null || tabs === void 0 ? void 0 : tabs.find(function (tab) { return (tab === null || tab === void 0 ? void 0 : tab.current) === currentFocus_1; });
            var currentIndex = currentTab ? tabs === null || tabs === void 0 ? void 0 : tabs.indexOf(currentTab) : 0;
            if (e.key === 'ArrowRight') {
                var nextTab = (_a = tabs === null || tabs === void 0 ? void 0 : tabs[((currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0) + 1) % ((tabs === null || tabs === void 0 ? void 0 : tabs.length) || 1)]) === null || _a === void 0 ? void 0 : _a.current;
                nextTab === null || nextTab === void 0 ? void 0 : nextTab.focus();
            }
            else if (e.key === 'ArrowLeft') {
                var previousTab = (_b = tabs === null || tabs === void 0 ? void 0 : tabs[((currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0) - 1 + ((tabs === null || tabs === void 0 ? void 0 : tabs.length) || 1)) %
                    ((tabs === null || tabs === void 0 ? void 0 : tabs.length) || 1)]) === null || _b === void 0 ? void 0 : _b.current;
                previousTab === null || previousTab === void 0 ? void 0 : previousTab.focus();
            }
        }
    };
    return (
    //Es-lint klager på at hvis man har onkeydown så må man også ha tabindex for å
    //gjøre komponenten reachable by keyboard, men onkeydown håndterer dette og det skal være
    //trygt å ignorere denne regelen.
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("div", __assign({ className: classNames('ffe-tab-group', { 'ffe-tab-group--no-break': noBreak }, className), role: "tablist", onKeyDown: handleKeyDown }, rest), React.Children.map(children, function (child, index) {
        return React.isValidElement(child) &&
            React.cloneElement(child, __assign(__assign({}, child.props), { ref: mergeRefs([child.props.ref, tabs === null || tabs === void 0 ? void 0 : tabs[index]]) }));
    })));
};
